import React from 'react'

export const FinanzaScreen = () => {
  return (
    <div>FinanzaScreen</div>
  )
}
